import React, { Component } from 'react'
import Dialog from 'material-ui/Dialog';
import { inject, observer } from 'mobx-react';
import { Button, ButtonType, TextButton, IconType, DialogHeader } from '@checkmarx/cx-ui';
import ToastrLevelsEnum from '../../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../../services/ui/toastrService';
import AdvancedRoleMappingList from '../advancedRoleMappingList'
import ValidationTopErrorMessage from '../../../portal/controls/validationTopErrorMessage';
import classNames from 'classnames';
import styles from './style.scss';
import { Scrollbars } from 'react-custom-scrollbars';

@inject('translationsStore', 'ldapRoleMappingsStore') @observer
export default class EditAdvancedRoleMappingDialog extends Component {

    updateMappings = () => {
        
        this.props.ldapRoleMappingsStore.setUpdateLdapServerRoleMappingsErrorMessage('');
        var isValid = this.props.ldapRoleMappingsStore.validateAllMappings();
        
        if (isValid === false) {
            const validationErrorMessage = this.props.translationsStore.translate('FORM_IS_NOT_COMPLETE_FILL_REQUIRED_FIELDS');
            this.props.ldapRoleMappingsStore.setUpdateLdapServerRoleMappingsErrorMessage(validationErrorMessage);
            return;
        }
        
        this.props.ldapRoleMappingsStore.updateLdapServerRoleMappings(this.props.ldapServerId).then(() => {

            this.props.closeDialog();
            var level = ToastrLevelsEnum.SUCCESS;
            var message = this.props.translationsStore.translate('ADVANCED_ROLE_MAPPING_SUCCESS_MESSAGE');
            ToastrService.triggerToastr({level, message});
        })
        .catch(() =>{

            this.openErrorDialog();
        });
    }

    addMapping = () => {
        
        this.props.ldapRoleMappingsStore.addMapping(this.props.ldapServerId);
    }

    render() {
        
        const title = <DialogHeader 
                        title={this.props.translationsStore.translate('ADVANCED_ROLE_MAPPING')}
                        closeClick={this.props.closeDialog}
                        displayCloseButton
                    />;
        
        const actions = [
            <span className='portal-blank-button' onClick={this.props.closeDialog}>
                {this.props.translationsStore.translate('CANCEL')}
            </span>,
            <Button 
                dataCy='btn-update-advanced-role-mapping'
                onClick={this.updateMappings}
                text={this.props.translationsStore.translate('SAVE')}>
            </Button>
        ];
        
        const customContentStyle = {
            width: '800px',
            backgroundColor: '#D82D49',
            padding: 0
        };

        let ldapRoleMappingsList = null;
        let addButton = null;
        
        if (this.props.ldapRoleMappingsStore.ldapRoleMappings) {
            
            const advancedRoleMappingListTranslations = {
                cxRole: this.props.translationsStore.translate('CX_ROLE'),           
                cxRoleTooltip: this.props.translationsStore.translate('CX_ROLE_HELP_TOOLTIP'),
                ldapGroupDn: this.props.translationsStore.translate('LDAP_GROUP_DN')
            };
            
            ldapRoleMappingsList = <AdvancedRoleMappingList 
                                        ldapRoleMappings={this.props.ldapRoleMappingsStore.ldapRoleMappings}
                                        translations={advancedRoleMappingListTranslations}
                                        ldapRoleMappingsStore =  {this.props.ldapRoleMappingsStore} />;

            addButton = <TextButton
                            dataCy='add-role-mapping-button'
                            text={this.props.translationsStore.translate('ADD_ROLE_MAPPING')}
                            iconType={IconType.add}
                            onClick={this.addMapping} />
        }

        return (
            <Dialog 
                title={title}
                modal={true}
                open={this.props.open}
                actions={actions}
                actionsContainerClassName={classNames(styles.editAdvancedRoleMappingDialogActions)}
                contentStyle={customContentStyle}>
                <div className={classNames(styles.editAdvancedRoleMappingErrorMessage)}>
                    <ValidationTopErrorMessage errorMessage={this.props.ldapRoleMappingsStore.updateLdapServerRoleMappingsErrorMessage} />
                </div>
                <Scrollbars style={{ height: '30vh', width: '100%' }} ref="scrollbars" >
                <div className={classNames(styles.advancedRoleMappingsElements)}>
                    {ldapRoleMappingsList}
                    </div>
                </Scrollbars>
                <div style={{marginTop: 15}}>
                        {addButton}
                </div>
            </Dialog>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/advancedRoleMappings/editAdvancedRoleMappingDialog/index.jsx